function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgUnfocusedBackToTopButton = function SvgUnfocusedBackToTopButton(props) {
  return h("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 186.779,
    height: 78,
    viewBox: "0 0 186.779 78"
  }, props), h("defs", null, h("filter", {
    id: "a",
    width: 78,
    height: 78,
    x: 0,
    y: 0,
    filterUnits: "userSpaceOnUse"
  }, h("feOffset", null), h("feGaussianBlur", {
    result: "blur",
    stdDeviation: 5
  }), h("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.302
  }), h("feComposite", {
    in2: "blur",
    operator: "in"
  }), h("feComposite", {
    in: "SourceGraphic"
  }))), h("g", {
    filter: "url(#a)"
  }, h("path", {
    fill: "#fff",
    d: "M39 15a24 24 0 1 1-24 24 24 24 0 0 1 24-24",
    "data-name": "FocusIn Border",
    opacity: 0.003
  })), h("g", {
    fill: "rgba(0,0,0,0.3)",
    stroke: "#fff",
    strokeWidth: 1.5,
    "data-name": "Ellipse 10",
    opacity: 0.5,
    transform: "translate(19 19)"
  }, h("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    stroke: "none"
  }), h("circle", {
    cx: 20,
    cy: 20,
    r: 19.25,
    fill: "none"
  })), h("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M40.087 46.985V33.673l3.989 4.265a1.13 1.13 0 0 0 1.619.039 1.087 1.087 0 0 0 .039-1.58l-5.964-6.359-.039-.039-.039-.039-.118-.115-.039-.039c-.039-.039-.079-.039-.118-.079-.039 0-.039 0-.079-.039-.039 0-.079-.039-.118-.039h-.395c-.039 0-.079.039-.118.039s-.039 0-.079.039-.079.039-.118.079l-.039.039-.118.118-.039.039-.039.039-5.964 6.4a1.12 1.12 0 0 0 .039 1.58 1.21 1.21 0 0 0 1.619-.039l3.831-4.3v13.303a1.146 1.146 0 0 0 2.291 0Z",
    "data-name": "Path 83"
  }));
};
export default SvgUnfocusedBackToTopButton;